import { render, staticRenderFns } from "./QuerySumInsuredTotals.vue?vue&type=template&id=7244e0d6&"
import script from "./QuerySumInsuredTotals.vue?vue&type=script&lang=js&"
export * from "./QuerySumInsuredTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports